import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { setLogout } from "state";

export const isTokenExpired = (token) => {
    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds
        return decodedToken.exp < currentTime;
    } catch (error) {
        return true; // If there's an error decoding, assume expired
    }
};

const useAuthCheck = () => {
    const token = useSelector((state) => state.token); 
    const dispatch = useDispatch();

    useEffect(() => {
        if (!token || isTokenExpired(token)) {            
            dispatch(setLogout());
        }
    }, [token, dispatch]); 
};

export default useAuthCheck;
